import type { AnswerOption, AnswerSelectionMode } from "@quizshow/protocol";

export function setCorrectAnswer(
  answers: AnswerOption[],
  optionId: string,
  selectionMode: AnswerSelectionMode,
  checked: boolean,
): AnswerOption[] {
  if (selectionMode === "single") {
    if (!checked) return answers;
    return answers.map((answer) => ({ ...answer, isCorrect: answer.optionId === optionId }));
  }
  return answers.map((answer) =>
    answer.optionId === optionId ? { ...answer, isCorrect: checked } : answer,
  );
}

export function normalizeSelectionMode(
  answers: AnswerOption[],
  selectionMode: AnswerSelectionMode,
): AnswerOption[] {
  if (selectionMode === "multiple") return answers;
  const firstCorrectIndex = Math.max(0, answers.findIndex((answer) => answer.isCorrect));
  return answers.map((answer, index) => ({ ...answer, isCorrect: index === firstCorrectIndex }));
}
